import React from 'react';
import type { FC, ReactNode } from 'react';
import { Box } from 'ink';
import InkSpinner from 'ink-spinner';
import { Text } from './Text.js';

export interface SpinnerProps {
  text?: ReactNode;
}

export const Spinner: FC<SpinnerProps> = ({ text }) => {
  const spinnerNode = (
    <Text skin="info">
      <InkSpinner type="dots" />
    </Text>
  );

  if (text) {
    return (
      <Box gap={1}>
        {spinnerNode}
        {typeof text === 'string' ? <Text>{text}</Text> : text}
      </Box>
    );
  }

  return spinnerNode;
};
